import dataProcess from './dataProcess'

const colors = {
  dataProcess,
}

export default colors
